import type { Company } from '@/types'

export const companyUtils = {
  filterActiveCompanies: (companies: Company[]) => companies.filter((company) => company.status),

  sortByUserCount: (companies: Company[]) => companies.sort((a, b) => (b.usersCount || 0) - (a.usersCount || 0)),

  getTopCompanies: (companies: Company[], limit: number) => companies.slice(0, limit),

  toChartData: (companies: Company[]) =>
    companies.map((company) => ({
      type: company.name || 'Unknown',
      count: company.usersCount || 0,
    })),

  toAnalyticsData: (companies: Company[]) =>
    companies.map((company) => ({
      id: company.id,
      name: company.name,
      logo: company.logo,
      usersCount: company.usersCount || 0,
      followRequestsCount: company.followRequestsCount || 0,
      status: company.status ? 'Active' : 'Inactive',
      createdAt: company.createdAt,
    })),

  getTopCompaniesByUsers: (companies: Company[], limit = 5) => {
    return companyUtils.toChartData(
      companyUtils.getTopCompanies(companyUtils.sortByUserCount(companyUtils.filterActiveCompanies(companies)), limit),
    )
  },

  filterBySearchTerm: (companies: any[], searchTerm: string) => {
    if (!searchTerm) return companies

    const lowerSearchTerm = searchTerm.toLowerCase()
    return companies
      .filter(
        (company) =>
          company.name?.toLowerCase().includes(lowerSearchTerm) ||
          company.owner?.fullName?.toLowerCase().includes(lowerSearchTerm) ||
          company.city?.toLowerCase().includes(lowerSearchTerm) ||
          company.state?.toLowerCase().includes(lowerSearchTerm),
      )
      .sort((a, b) => {
        const aName = a.name?.toLowerCase() || ''
        const bName = b.name?.toLowerCase() || ''
        const aStartsWith = aName.startsWith(lowerSearchTerm)
        const bStartsWith = bName.startsWith(lowerSearchTerm)
        if (aStartsWith && !bStartsWith) return -1
        if (!aStartsWith && bStartsWith) return 1
        return 0
      })
  },
}

export const companyUserUtils = {
  extractUserIds: (companyUsers: Array<{ userID?: string }>) =>
    companyUsers.map((user) => user.userID || '').filter(Boolean),
}
